import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReactTable from 'components/ReactTable/ReactTable.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import CloseIcon from '@material-ui/icons/Close';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import { wsUpdate, wsFindBy } from 'services/WService';
import { Done, Search } from '@material-ui/icons';
import { IconButton, InputAdornment } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  ...styles,
  closeButton: {
    float: 'right'
  }
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'FrgName', accessor: 'frgnName' },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Nombre', accessor: 'name' },
  { Header: 'Actions', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function ModalTaxe(props) {
  const classes = useStyles();
  const { open, setOpen, dataShop } = props;
  const buyDetail = props.buyDetail;
  const reload = props.reload;

  const [notify, showNotify] = useToasty();
  const [alert, setAlert] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const hideAlert = () => {
    setAlert(null);
  };

  function confirm(article, forceUpdate = undefined) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={
          forceUpdate !== undefined
            ? '!Desea forzar el cambio del producto!'
            : 'Desea agregar a : ' + article.ItemName
        }
        onConfirm={() => {
          saveUpdate(article.id, forceUpdate);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {forceUpdate !== undefined ? forceUpdate.message : '¡Esta acción tiene consecuencias!'}
      </SweetAlert>
    );
  }

  const [valueSearch, setValueSearch] = useState({});

  const handleChange = (e) => {
    setValueSearch({
      ...valueSearch,
      [e.target.name]: e.target.value
    });
  };

  function enter(e) {
    if (e.charCode == 13) {
      listArticles(valueSearch);
    }
  }

  const [articles, setArticles] = useState([]);
  const [providers, setProviders] = useState([]);

  const [providerId, setProviderId] = useState(null);

  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  async function listArticles(search) {
    if (!!search) {
      search = {
        ItemCode: search.ItemCode,
        ItemName: search.ItemName,
        FrgnName: search.FrgnName,
        base_business_partner_id: search.base_business_partner_id
      };
    }

    for (var clave in search) {
      if (search[clave] == undefined || search[clave] == null || search[clave] == '') {
        delete search[clave]; //eliminamos las claves nulas
      }
    }

    let response = await wsFindBy('logi/product', search);
    if (response.success) setArticles(response.data);
  }

  async function saveUpdate(articleId, forceUpdate) {
    let data = { logi_product_id: articleId };
    if (forceUpdate !== undefined) {
      data.force = 'Y';
    }

    let response = await wsUpdate('purch/purchase-detail', dataShop.id, data);
    if (response.success) {
      if (reload !== undefined && typeof reload === 'function') {
        reload();
      }
      showNotify(response.message);
      handleClose();
    } else {
      if (response.data?.force === 'Y') {
        confirm({ id: articleId }, { message: response.message });
      }
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (open) {
      setValueSearch({
        FrgnName: dataShop.FrgItem,
        base_business_partner_id: parseFloat(buyDetail.base_business_partner_id)
      });
      listArticles({
        FrgnName: dataShop.FrgItem,
        base_business_partner_id: parseFloat(buyDetail.base_business_partner_id)
      });
      listProviders();
    }
  }, [open]);

  return (
    <div>
      <Toasty action={notify} />
      <Dialog open={open} onClose={handleClose} maxWidth="lg">
        <DialogTitle>
          {dataShop.Dscription}
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridItem xs={12} lg={3}>
              <Autocomplete
                options={providers}
                getOptionLabel={(option) => option.CardName}
                defaultValue={
                  !!valueSearch
                    ? providers.find((provider) => {
                        let isProviderId = provider.id == valueSearch.base_business_partner_id;
                        if (isProviderId) {
                          if (!providerId) {
                            setProviderId(provider.id);
                          }
                          return true;
                        }
                        return false;
                      })
                    : null
                }
                renderInput={(params) => (
                  <TextField {...params} label="Proveedor" margin="normal" />
                )}
                onChange={(e, item) => {
                  if (!!item) {
                    return (
                      setProviderId(item.id),
                      setValueSearch({
                        ...valueSearch,
                        base_business_partner_id: item.id
                      })
                    );
                  } else {
                    delete valueSearch.base_business_partner_id;
                    setValueSearch({ ...valueSearch });
                    setProviderId(null);
                  }
                }}
              />
            </GridItem>
            <GridItem xs={12} lg={2}>
              <TextField
                label="Código producto"
                fullWidth
                type="text"
                margin="normal"
                name="ItemCode"
                defaultValue=""
                onChange={handleChange}
                onKeyPress={enter}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} lg={3}>
              <TextField
                label="Nombre producto"
                fullWidth
                type="text"
                margin="normal"
                name="ItemName"
                defaultValue=""
                onChange={handleChange}
                onKeyPress={enter}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} lg={2}>
              <TextField
                label="Cód. Prod. Prov."
                fullWidth
                type="text"
                margin="normal"
                name="FrgnName"
                defaultValue={dataShop.FrgItem}
                onChange={handleChange}
                onKeyPress={enter}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  )
                }}
              />
            </GridItem>
            <GridItem xs={12} lg={2} style={{ display: 'flex', alignItems: 'center' }}>
              <Button size="sm" onClick={() => listArticles(valueSearch)}>
                Buscar
              </Button>
            </GridItem>
          </GridContainer>
          {alert}
          <ReactTable
            indexRow={[0, 1, 3]}
            widthRow={[80, 120, 450]}
            defaultWidth={1000}
            columns={columns}
            data={articles.map((article, i) => {
              return {
                num: i + 1,
                frgnName: article.FrgnName,
                code: article.ItemCode,
                name: article.ItemName,
                actions: (
                  <div className="actions-right">
                    <Button
                      justIcon
                      size="sm"
                      round
                      onClick={() => {
                        confirm(article);
                      }}
                      color={props.themeContext.buttonColorSuccess}
                    >
                      <Done />
                    </Button>
                  </div>
                )
              };
            })}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
});
